import { SingleValue } from 'react-select';
import { SelectOption } from './types';
import { SelectView } from './view';

type SelectProps = {
    options: SelectOption[];
    optionSelected: (option: SingleValue<SelectOption>) => void;
    defaultValue?: SelectOption;
    value?: SelectOption['value'];
};

export const ControlSelect = ({ options, optionSelected, defaultValue, value }: SelectProps) => {
    const selectedOption = options.find((o) => o.value === value);

    return (
        <SelectView
            value={selectedOption}
            classNamePrefix="react-selector"
            menuPlacement={'auto'}
            options={options}
            defaultValue={defaultValue}
            onChange={optionSelected}
        />
    );
};
